<template>
  <div>
    <div v-if="dialogType == 'yellowType'" class="yellowType">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        :append-to-body="true"
        :modal="false"
        :wrapperClosable="false"
        customClass="yellowType"
        @close="handleClose(false)"
      >
        <div>
          {{ $t(`authorization.organization.confirmDelete1`)
          }}<span class="yellow">
            {{ $t(`authorization.organization.confirmDelete2`) }}</span
          ><span>!</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose(false)">{{
            $t(`common.cancel`)
          }}</el-button>
          <el-button type="primary" @click="handleClose(true)">{{
            $t(`common.confirm`)
          }}</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-if="dialogType == 'normalType'">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogFormVisible"
        :append-to-body="true"
        :modal="false"
        :wrapperClosable="false"
        class="normalType"
        @close="handleClose(false)"
      >
        <div v-if="eventType == 'addResourceGroup'">
          <div>{{ $t(`authorization.organization.selectResGroup`) }}</div>
          <Table
            :tableConfig="tableConfig"
            :tableData="tableData"
            @callBackAction="callBackAction"
            :api="api"
            :type="tableType"
            @handleSelectionChange="handleSelectionChange"
          />
        </div>
        <div v-else>
          <el-form :model="addOrgForm" class="searchForm">
            <el-form-item
              :label="$t(`authorization.organization.selectAddorInput`)"
              v-if="addType == 'addChild'"
            >
              <el-radio v-model="addOrgForm.radio" label="1">{{
                $t(`authorization.organization.childOrg`)
              }}</el-radio>
              <el-radio v-model="addOrgForm.radio" label="2">{{
                $t(`authorization.organization.position`)
              }}</el-radio>
            </el-form-item>
            <el-form-item :label="$t(`authorization.organization.inputAddOrg`)">
              <el-input
                v-model="addOrgForm.inputName"
                :placeholder="$t(`authorization.organization.inputOrg`)"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose(false)">{{
            $t(`common.cancel`)
          }}</el-button>
          <el-button
            type="primary"
            @click="handleClose(true)"
            v-if="eventType != 'addResourceGroup'"
            >{{ $t(`common.confirm`) }}</el-button
          >
          <el-button
            type="primary"
            @click="handleClose(true)"
            v-if="eventType == 'addResourceGroup'"
            >{{ $t(`common.add`) }}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Table from "@/components/table/index.vue";
import { positionRelResGroup, userRelResGroup } from "@/api/authorization.js";

export default {
  components: { Table },
  data() {
    return {
      selectedItems: [],
      api: {},
      tableType: "",
      addOrgForm: {},
    };
  },
  props: {
    tableConfig: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: "",
    },
    dialogType: {
      type: String,
      default: "",
    },
    addType: {
      type: String,
      default: "",
    },
    addResourceGroup: {
      type: String,
      default: "",
    },
    eventType: {
      type: String,
      default: "",
    },
    tableData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    width: {
      type: String,
      default: "",
    },
    handelNode: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
  },
  methods: {
    callBackAction(param) {
      this[param.event](param);
    },
    handleSelectionChange(obj) {
      this.selectedItems = obj.selectedItems;
    },
    query(param) {
      this.$emit("queryResourceGroupNot", param);
      //查询他未关联的资源分组
    },
    handleClose(flag) {
      if (this.eventType == "addResourceGroup"&&flag) {
        //新增资源分组
        // console.log("selectedItems", this.selectedItems);
        //用户新增资源分组/user/relResGroup
        //let data={
        //"userId":"202107310001",
        //"rootOrgCode":"qcc",
        //"resGroupCodes":["maintainers"]
        //}
        //用户新增资源分组/position/relResGroup
        let codes = [];
        this.selectedItems.forEach((item) => {
          codes.push(item.resGroupCode);
        });
        if (this.handelNode.positionCode) {
          let data = {
            positionCode: this.handelNode.positionCode,
            rootOrgCode: this.handelNode.rootOrgCode,
            resGroupCodes: codes,
          };
          positionRelResGroup(data).then(res => {
            if(res.code=== "AUTH_000000"){
              //岗位关联
            this.$emit("query");
            }
            this.$message({
              type: res.code=== "AUTH_000000"?"success":"warning",
              message: res.msg,
            });
          });
        } else {
          // console.log('用户关联')
          //用户关联
          let data = {
            userId: this.handelNode.userId,
            rootOrgCode: this.handelNode.rootOrgCode,
            resGroupCodes: codes,
          };
          //调用接口，刷新右侧抽屉的列表
          userRelResGroup(data).then(res => {
            if(res.code=== "AUTH_000000"){
              this.$emit("query");
            }
            this.$message({
              type: res.code=== "AUTH_000000"?"success":"warning",
              message: res.msg,
            });
          });
        }
      } else if (this.dialogType == "yellowType"&&flag) {
        // console.log("yellowType");
        this.$emit("confirmDeleteRel");
      }
      this.$emit("setDialog", flag);
    },
  },
};
</script>
<style lang="less" scoped>
/* ::v-deep .el-dialog__header {
  background-color: #feaa09;
}
::v-deep .el-dialog__title {
  color: white;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
}
::v-deep .el-button:focus,
.el-button:hover {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
} */

::v-deep .el-dialog {
  width: 660px;
}
::v-deep .yellowType {
  width: 420px;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #343c6a;
  background: #343c6a;
}
::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #343c6a;
}
</style>
